<template>
  <v-container fluid class="pa-0" style="background: var(--v-background-base)">
    <v-row class="mb-10" justify="center" no-gutters>
      <v-col class="mb-10 pb-10" cols="12" sm="9" md="9" xl="7" style="background: var(--v-muted-base)">
        <div class="pa-3 tituloProduto">
          <div style="display: flex; justify-content: space-between; align-items: baseline">
            <span style="cursor: pointer" @click="voltar()">
              <!-- <v-icon color="white" small right>fas fa-arrow-left</v-icon> -->
            </span>
            <span class="subtitle-1 font-weight-bold white--text">
              <v-icon small color="white" left>fas fa-{{ item.icon }}</v-icon>
              {{ item.titulo }}
            </span>
            <span></span>
          </div>
        </div>

        <v-row v-if="bpfepj" style="padding: 15px;">
          <v-col cols="12">
            <p class="black--text font-weight-bold subtitle-1 mb-0">Para quem é a Cotação</p>
          </v-col>
          <v-col class="pt-0" cols="6 pt-0">
            <v-btn color="botao" block @click="setPessoa('pf','item1')">Para você</v-btn>
          </v-col>
          <v-col class="pt-0" cols="6">
            <v-btn color="botao" block @click="setPessoa('pj', 'item3')">Sua Empresa</v-btn>
          </v-col>
        </v-row>
        <pessoa-juridica v-if="bpessoajuridica" />
        <pessoa-fisica v-if="bpessoafisica" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getTodosProdutos } from "./produtoUtil";
import cPessoaFisica from "./pessoa-fisica";
import cPessoaJuridica from "./pessoa-juridica";

export default {
  components: {
    "pessoa-fisica": cPessoaFisica,
    "pessoa-juridica": cPessoaJuridica,
  },
  data () {
    return {
      bpessoafisica: false,
      bpessoajuridica: false,
      bpessoaitem: "",
      bpfepj: false,
      configs: [],
      item: {},
      seguradoras: [],
      origin: null,
      personType: null,
    };
  },
  created () {
    this.origin = this.$route.query.origin;
    this.personType = this.$route.query.personType;

    if (this.personType) {
      this.setPessoa(this.personType);
    } else {
      this.setPessoa();
    }
  },
  mounted () {
    let produtos = getTodosProdutos();
    produtos.forEach(item => {
      if (item.id == this.id) {
        this.item = item;
      }
    });
  },
  props: {
    id: null,
  },
  methods: {
    setPessoa (_pessoa) {
      this.bpessoajuridica = false;
      this.bpessoafisica = false;
      this.bpfepj = false;

      if (_pessoa) _pessoa = _pessoa.toLowerCase();
      switch (_pessoa) {
        case "pf":
          this.bpessoafisica = true;
          break;

        case "salesforce":
        case "pj":
          this.bpessoajuridica = true;
          break;

        case "corretor":
        default:
          this.bpfepj = true;
          break;
      }
    },
    voltar () {
      localStorage.removeItem("current_quote");
      localStorage.removeItem("current_addfields");
      this.$util.link("produtos", null, {
        origin: this.origin,
        personType: this.personType,
      });
    },
  },
};
</script>

<style>
.botao {
  background-color: var(--v-btnprimary-base) !important;
  border-color: var(--v-btnprimary-base) !important;
  color: var(--v-foreground-base) !important;
}
/* stepper style */
.v-stepper__content {
  border: 0 !important;
  margin-left: 0 !important;
}
.v-stepper__step--active > span,
.v-stepper__step--inactive > span {
  display: none;
}
.v-stepper {
  background-color: transparent !important;
}
.v-stepper__step,
.v-stepper__content {
  padding-left: 5px !important;
  padding-top: 0px !important;
  padding-bottom: 5px !important;
}

/*  */
.tituloProduto {
  background-color: var(--v-primary);
  position: relative;
  width: 100%;
  top: 0;
  height: 50px;
}
</style>
